module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerPlaceHolderWithWalleteWeb && Object.keys(_vm.bannerPlaceHolderWithWalleteWeb).length) ? _c('p', {
    staticClass: "offer-message p-2",
    style: ([_vm.bannerPlaceHolderWithWalleteWeb.styles])
  }, [_vm._v("\n          " + _vm._s(_vm.bannerPlaceHolderWithWalleteWeb.text) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c9aa5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/walletMessage.vue
// module id = 1487
// module chunks = 14 15